/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import * as default_data from '../config.js'
import Modal from 'react-modal';

const WarningPopup = ({ triggerWarningPopup, setTriggerWarningPopup }) => {

  const [loaded, setLoaded] = useState(false);
  var loaded_static = false;

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    setTriggerWarningPopup(0);
    setIsOpen(false);
  }

  useEffect(() => {
    if(default_data.default_tenant !== "AskSageDoD" && default_data.default_tenant !== "AskSageCIV" && default_data.default_has_government_banner !== true) {
        setTriggerWarningPopup(0);
        setIsOpen(false);
        return;
    }
    if (triggerWarningPopup) {
      if (triggerWarningPopup === 1) {
        setIsOpen(true)
      }
    }
  }, [triggerWarningPopup]);

  useEffect(() => {

    if(loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    if(default_data.default_tenant === "AskSageDoD" || default_data.default_tenant === "AskSageCIV" || default_data.default_has_government_banner === true) {
        setIsOpen(true);
        return;
    }
}, [])

    const customStyles = {
    overlay: {
      position: 'fixed',
      zIndex: 1020,
      top: 0,
      left: 0,
      width: '100vw',
      borderRadius: '0.375rem',
      height: '100vh',
      overflow: 'hidden',
      background: 'rgba(255, 255, 255, 0.75)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    content: {
      background: '#050038',
      color: '#e9ecef',      
      width: '75%',
      margin: '5%',
      borderRadius: '30px 10px 10px 30px',
      inset: 0,
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: 'calc(100vh - 2rem)',
      overflow: 'auto',
      position: 'relative',
      border: '1px solid #ccc'
    },
  };

  return (
    <Modal
    isOpen={modalIsOpen}
    onAfterOpen={afterOpenModal}
    onRequestClose={closeModal}
    style={customStyles}
    contentLabel="System Use Notification"              
    className="modal-background"
    >
        {
          default_data.default_tenant === "AskSageDoD" ?              
          <div className="dod_banner">
          <h1>NOTICE TO USERS: This is a U.S. Government information system.</h1>
        <p>By accessing and using this system, you acknowledge and consent to the following:</p>
        <ol>
            <li>This is a Department of Defense (DoD) computer system.</li>
            <li>All activities on this system may be monitored, recorded, and audited.</li>
            <li>Unauthorized use of this system is prohibited and may result in disciplinary action, civil and criminal penalties, and/or other administrative sanctions.</li>
            <li>Use of this system constitutes consent to monitoring and recording.</li>
            <li>There is no expectation of privacy on this system.</li>
            <li>Any communication or data transiting or stored on this system may be disclosed or used for any lawful government purpose.</li>
            <li>This system may contain sensitive information protected by various federal laws, regulations, and policies. Unauthorized access or disclosure of this information may result in legal action.</li>
            <li>If you do not consent to the terms stated above, please disconnect from this system immediately.</li>
        </ol>
        </div>
        :
        <div className="dod_banner">
        <h1>NOTICE TO USERS: This is a U.S. Government information system.</h1>
      <p>By accessing and using this system, you acknowledge and consent to the following:</p>
      <ol>
          <li>This is a U.S. Government computer system.</li>
          <li>All activities on this system may be monitored, recorded, and audited.</li>
          <li>Unauthorized use of this system is prohibited and may result in disciplinary action, civil and criminal penalties, and/or other administrative sanctions.</li>
          <li>Use of this system constitutes consent to monitoring and recording.</li>
          <li>There is no expectation of privacy on this system.</li>
          <li>Any communication or data transiting or stored on this system may be disclosed or used for any lawful government purpose.</li>
          <li>This system may contain sensitive information protected by various federal laws, regulations, and policies. Unauthorized access or disclosure of this information may result in legal action.</li>
          <li>If you do not consent to the terms stated above, please disconnect from this system immediately.</li>
      </ol>
      </div>
      }
        <Button onClick={closeModal}>I acknowledge and consent.</Button>             
    </Modal>
  );
}
export default WarningPopup;